import { FieldValidator } from './fieldValidator';
import { isIPv4 } from 'is-ip';

export const ipv4Validator: FieldValidator<string | undefined> = {
  errorMessage: 'IP address is invalid',
  isValid: (value?: string) => {
    if (value && isIPv4(value)) {
      return true;
    }

    return false;
  }
};
